import { ConversationStatus } from 'shared/typings/conversations/status/ConversationStatus'

const OPEN = [ConversationStatus.OPEN, ConversationStatus.PENDING]
const CLOSED = [ConversationStatus.CLOSED]
const ALL = [ConversationStatus.OPEN, ConversationStatus.PENDING, ConversationStatus.CLOSED]

export const STATUSES_FOR_PILL: Record<string, ConversationStatus[]> = {
  open: OPEN,
  closed: CLOSED,
  all: ALL,
}

export type Pill = 'open' | 'closed' | 'all'
